import React from 'react';
import Plot from 'react-plotly.js';
import { MetricWithSeries } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';
import MetricHeader from './MetricHeader';
import {
    CHART_BLUE,
    CHART_BLUE_FILL,
    CHART_CONFIG,
    TICK_SPACING,
    categoryRange,
    chartLayout,
    seriesLabels,
    seriesValues,
    yRangeWithHeadroom,
} from './chartTheme';

interface ConversationsCardProps {
    conversations: MetricWithSeries;
}

const ConversationsCard: React.FC<ConversationsCardProps> = ({ conversations }) => {
    const labels = seriesLabels(conversations.series);
    const values = seriesValues(conversations.series);

    return (
        <DashboardCard title="Conversations" className="ad-card-chart ad-col-conversations">
            <div className="ad-card-body">
                <MetricHeader displayValue={conversations.displayValue} deltaPct={conversations.deltaPct} />
                <div className="ad-chart">
                    <Plot
                        data={[
                            {
                                type: 'scatter',
                                mode: 'lines',
                                fill: 'tozeroy',
                                fillcolor: CHART_BLUE_FILL,
                                x: labels,
                                y: values,
                                line: { color: CHART_BLUE, width: 1.5, shape: 'spline', smoothing: 0 },
                            },
                        ]}
                        layout={chartLayout({
                            margin: { l: 40, r: 28, t: 18, b: 28 },
                            xaxis: { ...TICK_SPACING, range: categoryRange(labels.length, 0.5) },
                            yaxis: { ...TICK_SPACING, range: yRangeWithHeadroom(values) },
                        })}
                        config={CHART_CONFIG}
                        style={{ width: '100%', height: '100%' }}
                        useResizeHandler={true}
                    />
                </div>
            </div>
        </DashboardCard>
    );
};

export default ConversationsCard;
